import IntroOrSummary from './IntroOrSummary'

export default IntroOrSummary
